// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ImJZ","resendInfoText":"OnGoingPaymentBox_resendInfoText__1ZbMH"};